export const defaultOfficeLabels = {
  label: 'test-default',
  positionAccount: 'Cuentas',
  ebr: 'EBR',
};
